// Import guards
import auth from './middleware/auth.js';

// Import views
import advancedSearch from './views/AdvancedSearch.vue';

import authChangePassword from './views/auth/ChangePassword.vue';
import authEmailVerification from './views/auth/EmailVerification.vue';
import authLogin from './views/auth/Login.vue';
import authLogout from './views/auth/Logout.vue';
import authPasswordEmail from './views/auth/PasswordEmail.vue';
import authPasswordReset from './views/auth/PasswordReset.vue';
import authProfile from './views/auth/EditProfile.vue';
import authRegister from './views/auth/Register.vue';
import authSocialLogin from './views/auth/SocialLogin.vue';

import calendar from './views/calendar/Index.vue';

import dashboard from './views/dashboard/Index.vue';

import home from  './views/pages/Home.vue';

import pagePrivacyPolicy from './views/pages/PrivacyPolicy.vue';
import pageTerms from './views/pages/Terms.vue';

import search from './views/Search.vue';

import settings from './views/settings/Index.vue';

import startdeskIndex from './views/startdesks/Index.vue';
import startdeskAdd from './views/startdesks/Add.vue';
import startdeskView from './views/startdesks/View.vue';
import startdeskEdit from './views/startdesks/Edit.vue';
import startdeskCategoriesIndex from './views/startdesks/categories/Index.vue';
import startdeskCategoriesAdd from './views/startdesks/categories/Add.vue';
import startdeskCategoriesEdit from './views/startdesks/categories/Edit.vue';

import support from './views/Support.vue';

import tileIndex from './views/tiles/Index.vue';
import tileAdd from './views/tiles/Add.vue';
import tileEdit from './views/tiles/Edit.vue';
import tileCategoriesIndex from './views/tiles/categories/Index.vue';
import tileCategoriesAdd from './views/tiles/categories/Add.vue';
import tileCategoriesEdit from './views/tiles/categories/Edit.vue';

import userIndex from './views/users/Index.vue';
import userAdd from './views/users/Add.vue';
import userEdit from './views/users/Edit.vue';

import wallpaperIndex from './views/wallpapers/Index.vue';
import wallpaperAdd from './views/wallpapers/Add.vue';
import wallpaperCategoriesIndex from './views/wallpapers/categories/Index.vue';
import wallpaperCategoriesAdd from './views/wallpapers/categories/Add.vue';
import wallpaperCategoriesEdit from './views/wallpapers/categories/Edit.vue';






export default [
    {
        path: '/',
        component: home,
        name: 'home'
    },

    // auth
    {
        path: '/email/verify/:id?',
        component: authEmailVerification,
        name: 'verification.verify'
    },
    {
        path: '/login',
        component: authLogin,
        name: 'login'
    },
    {
        path: '/logout',
        component: authLogout,
        name: 'logout'
    },
    {
        path: '/login/social/callback/:provider',
        component: authSocialLogin,
        name: 'login.social'
    },
    {
        path: '/password',
        beforeEnter: auth,
        component: authChangePassword,
        name: 'profile.password'
    },
    {
        path: '/password/email',
        component: authPasswordEmail,
        name: 'password.email'
    },
    {
        path: '/password/reset/:token',
        component: authPasswordReset,
        name: 'password.reset'
    },
    {
        path: '/privacy-policy',
        component: pagePrivacyPolicy,
        name: 'page.privacy-policy'
    },
    {
        path: '/profile',
        beforeEnter: auth,
        component: authProfile,
        name: 'profile.edit'
    },
    {
        path: '/register',
        component: authRegister,
        name: 'register'
    },
    {
        path: '/settings',
        component: settings,
        name: 'settings'
    },

    // startdesks
    {
        path: '/startdesks',
        beforeEnter: auth,
        component: startdeskIndex,
        name: 'startdesks'
    },
    {
        path: '/startdesks/add/:category?',
        beforeEnter: auth,
        component: startdeskAdd,
        name: 'startdesks.add'
    },
    {
        path: '/startdesks/:startdesk/edit',
        beforeEnter: auth,
        component: startdeskEdit,
        name: 'startdesks.edit'
    },
    {
        path: '/startdesks/categories',
        beforeEnter: auth,
        component: startdeskCategoriesIndex,
        name: 'startdesks.categories',
        meta: { authorize: ['admin'] }
    },
    {
        path: '/startdesks/categories/add',
        beforeEnter: auth,
        component: startdeskCategoriesAdd,
        name: 'startdesks.categories.add',
        meta: { authorize: ['admin'] }
    },
    {
        path: '/startdesks/categories/:category/edit',
        beforeEnter: auth,
        component: startdeskCategoriesEdit,
        name: 'startdesks.categories.edit',
        meta: { authorize: ['admin'] }
    },
    {
        path: '/terms-of-service',
        component: pageTerms,
        name: 'page.terms'
    },

    // tiles
    {
        path: '/tiles',
        beforeEnter: auth,
        component: tileIndex,
        name: 'tiles',
        meta: { authorize: ['admin'] }
    },
    {
        path: '/tiles/add/:category?',
        beforeEnter: auth,
        component: tileAdd,
        name: 'tiles.add'
    },
    {
        path: '/tiles/:tile/edit',
        beforeEnter: auth,
        component: tileEdit,
        name: 'tiles.edit'
    },
    {
        path: '/tiles/categories',
        beforeEnter: auth,
        component: tileCategoriesIndex,
        name: 'tiles.categories',
        meta: { authorize: ['admin'] }
    },
    {
        path: '/tiles/categories/add',
        beforeEnter: auth,
        component: tileCategoriesAdd,
        name: 'tiles.categories.add',
        meta: { authorize: ['admin'] }
    },
    {
        path: '/tiles/categories/:category/edit',
        beforeEnter: auth,
        component: tileCategoriesEdit,
        name: 'tiles.categories.edit',
        meta: { authorize: ['admin'] }
    },

    // users
    {
        path: '/users',
        beforeEnter: auth,
        component: userIndex,
        name: 'users',
        meta: { authorize: ['admin'] }
    },
    {
        path: '/users/add',
        beforeEnter: auth,
        component: userAdd,
        name: 'users.add',
        meta: { authorize: ['admin'] }
    },
    {
        path: '/users/:user/edit',
        beforeEnter: auth,
        component: userEdit,
        name: 'users.edit',
        meta: { authorize: ['admin'] }
    },

    // wallpapers
    {
        path: '/wallpapers',
        beforeEnter: auth,
        component: wallpaperIndex,
        name: 'wallpapers',
        meta: { authorize: ['admin'] }
    },
    {
        path: '/wallpapers/add',
        beforeEnter: auth,
        component: wallpaperAdd,
        name: 'wallpapers.add',
        meta: { authorize: ['admin'] }
    },
    {
        path: '/wallpapers/categories',
        beforeEnter: auth,
        component: wallpaperCategoriesIndex,
        name: 'wallpapers.categories',
        meta: { authorize: ['admin'] }
    },
    {
        path: '/wallpapers/categories/add',
        beforeEnter: auth,
        component: wallpaperCategoriesAdd,
        name: 'wallpapers.categories.add',
        meta: { authorize: ['admin'] }
    },
    {
        path: '/wallpapers/categories/:category/edit',
        beforeEnter: auth,
        component: wallpaperCategoriesEdit,
        name: 'wallpapers.categories.edit',
        meta: { authorize: ['admin'] }
    },

    // my day
    {
        path: '/my-day',
        beforeEnter: auth,
        component: dashboard,
        name: 'dashboard.index'
    },

    // calendar
    {
        path: '/calendar',
        beforeEnter: auth,
        component: calendar,
        name: 'calendar.index'
    },

    // pages
    {
        path: '/advanced-search',
        component: advancedSearch,
        name: 'advanced-search'
    },
    {
        path: '/search',
        component: search,
        name: 'search'
    },
    {
        path: '/support',
        component: support,
        name: 'support'
    },

    // catch all paths
    {
        path: '/:u?/:startdesk',
        component: startdeskView,
        name: 'startdesks.view'
    },
    {
        path: '*',
        redirect: '/'
    }
]



// WEBPACK FOOTER //
// ./resources/assets/js/routes.js